import React, { useState } from 'react'
import { Box, TextField, Select, MenuItem, IconButton, InputAdornment } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid';
import dataGridStyle from '../../styles/dataGridStyle';
import TableRowActions from '../TableRowActions';
import borderStyle from '../../styles/borderStyle'
import SearchIcon from '@mui/icons-material/Search';

const firstRow = {
    code: "",
    cost_rate: "",
    description: "",
    discType: "Amt",
    id: 1,
    markup: "",
    net_tax: "",
    qty: "",
    tax_amt: "",
    tax_perc: "",
    taxable_amt: "",
    tot_amt: "",
    trade_disc: "",
    trade_rate: ""
}

function AddPartsTable() {
    const [rows, setRows] = useState([firstRow])
    
    const columns = [
        { field: 'id', headerName: 'No', flex: 0.2, minWidth: 40 },
        {
            field: 'code',
            headerName: 'Category',
            flex: 1,
            minWidth: 100,
            renderCell: (params) => (
                <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputProps={{
                        style: borderStyle.root,
                        endAdornment: (
                          <InputAdornment>
                            <IconButton>
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    value={params.row.code}
                    onChange={(e) => handleFieldChange(e, params.row.id, 'code')}
                    onKeyDown={(e) => handleTextFieldKeyDown(e, params.row.id, 'code')}
                />
            ),
        },
        {
            field: 'description',
            headerName: ' Task Description',
            flex: 1.5,
            minWidth: 200,
            renderCell: (params) => (
                <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputProps={{
                        style: borderStyle.root
                    }}
                    value={params.row.description}
                    onChange={(e) => handleFieldChange(e, params.row.id, 'description')}
                />
            ),
        },
        {
            field: 'qty',
            headerName: 'Hours',
            flex: 0.5,
            minWidth: 50,
            renderCell: (params) => (
                <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputProps={{
                        style: borderStyle.root
                    }}
                    value={params.row.qty}
                    onChange={(e) => handleFieldChange(e, params.row.id, 'qty')}
                />
            ),
        },
        {
            field: 'cost_rate',
            headerName: 'Cost Rate',
            flex: 1,
            minWidth: 100,
            renderCell: (params) => (
                <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputProps={{
                        style: borderStyle.root
                    }}
                    value={params.row.cost_rate}
                    onChange={(e) => handleFieldChange(e, params.row.id, 'cost_rate')}
                />
            ),
        },
        {
            field: 'markup',
            headerName: 'MarKUp%',
            flex: 0.7,
            minWidth: 70,
            renderCell: (params) => (
                <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputProps={{
                        style: borderStyle.root
                    }}
                    value={params.row.markup}
                    onChange={(e) => handleFieldChange(e, params.row.id, 'markup')}
                />
            ),
        },
       
        {
            field: 'trade_rate',
            headerName: 'Trade Rate',
            flex: 1,         
            minWidth: 100,
            renderCell: (params) => (
                <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputProps={{
                        style: borderStyle.root
                    }}
                    value={params.row.trade_rate}
                    onChange={(e) => handleFieldChange(e, params.row.id, 'trade_rate')}
                />
            ),
        },
        {
            field: 'discType',
            headerName: 'Disc Type',
            flex: 0.9,
            minWidth: 90,
            renderCell: (params) => (
                <Select
                    fullWidth
                    variant="outlined"
                    style={borderStyle.root}
                    value={params.row.discType}
                    onChange={(e) => handleFieldChange(e, params.row.id, 'discType')}
                    size="small"
                >
                    <MenuItem value="Amt">Amt</MenuItem>
                    <MenuItem value="Perc">%</MenuItem>
                </Select>
            ),
        },
        {
            field: 'trade_disc',
            headerName: 'Trade Disc',
            flex: 1,
            minWidth: 100,
            renderCell: (params) => (
                <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputProps={{
                        style: borderStyle.root
                    }}
                    value={params.row.trade_disc}
                    onChange={(e) => handleFieldChange(e, params.row.id, 'trade_disc')}
                />
            ),
        },
        {
            field: 'taxable_amt',
            headerName: 'Taxable Amount',
            flex: 1,
            minWidth: 120,
            renderCell: (params) => (
                <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputProps={{
                        style: borderStyle.root
                    }}
                    value={params.row.taxable_amt}
                    onChange={(e) => handleFieldChange(e, params.row.id, 'taxable_amt')}
                />
            ),
        },
        {
            field: 'net_tax',
            headerName: 'Net Taxable',
            flex: 1,
            minWidth: 100,
            renderCell: (params) => (
                <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputProps={{
                        style: borderStyle.root
                    }}
                    value={params.row.net_tax}
                    onChange={(e) => handleFieldChange(e, params.row.id, 'net_tax')}
                />
            ),
        },
        {
            field: 'tax_perc',
            headerName: 'Tax%',
            flex: 0.6,
            minWidth: 60,
            renderCell: (params) => (
                <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputProps={{
                        style: borderStyle.root
                    }}
                    value={params.row.tax_perc}
                    onChange={(e) => handleFieldChange(e, params.row.id, 'tax_perc')}
                />
            ),
        },
        {
            field: 'tax_amt',
            headerName: 'Tax Amount',
            flex: 1,
            minWidth: 100,
            renderCell: (params) => (
                <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputProps={{
                        style: borderStyle.root
                    }}
                    value={params.row.tax_amt}
                    onChange={(e) => handleFieldChange(e, params.row.id, 'tax_amt')}
                />
            ),
        },
        {
            field: 'tot_amt',
            headerName: 'Total Amount',
            flex: 1,
            minWidth: 100,
            renderCell: (params) => (
                <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputProps={{
                        style: borderStyle.root
                    }}
                    value={params.row.tot_amt}
                    onChange={(e) => handleFieldChange(e, params.row.id, 'tot_amt')}
                />
            ),
        }, 
        {
            field: 'delete',
            headerName: '',
            flex:0.8,
            minWidth: 90,
            renderCell: (params) => (
                <TableRowActions rows={rows} params={params} setRows={setRows} firstRow={firstRow} field='code'/>
            ),
        },
        // Add more columns as needed
    ];

    const handleFieldChange = (e, id, field) => {
        const updatedRows = rows.map((row) => {
            if (row.id === id) {
                return { ...row, [field]: e.target.value };
            }
            return row;
        });
        setRows(updatedRows);
    };
    const handleTextFieldKeyDown = (e, id, field) => {
        // Prevent the default behavior when the spacebar is pressed

      };

    return (

        <Box sx={dataGridStyle.root}>
            <DataGrid
                columnHeaderHeight={42}
                // rowHeight={40}
                rows={rows}
                columns={columns}
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 5,
                        },
                    },
                }}
                pageSizeOptions={[5]}
                disableRowSelectionOnClick
            />
        </Box>

    )
}

export default AddPartsTable